import {useTranslation} from '@/translations/i18n.tsx'
import {CategoryCard} from './category-card'
import {NotificationTextIcon} from '@components/ui/icon'
import {SettingsCard} from '@features/settings/components/settings-card'
import {useMe} from '@features/user/queries/useMe'
import {cn, raise} from '@utilities/helpers'
import {useState} from 'react'
import {Switch} from '@components/ui/switch'
import {ChangePhoneModal} from '@/features/settings/components/change-phone-modal'
import {useChangeOptionSms} from '@features/settings/queries/useChangeOptionSms'
import {Button} from '@components/ui/button'
import {Spinner} from '@components/ui/spinner'
import {SETTINGS_SECTION_WRAPPER_CLASSNAME} from '@features/settings/constants.ts'

export const Notifications = () => {
    const {t} = useTranslation()
    const userMeQuery = useMe({throwOnError: true})
    const user = userMeQuery.data ?? raise('user is nullish')
    const [isChangePhoneModalOpen, setIsChangePhoneModalOpen] = useState(false)
    const changeOptionSmsMutation = useChangeOptionSms()
    const isCompleted = !!user.phone

    return (
        <div className={SETTINGS_SECTION_WRAPPER_CLASSNAME}>
            <CategoryCard
                icon={NotificationTextIcon}
                title={t('settings:personal_information:notifications_label')}
                description={t('settings:personal_information:notifications_description')}
            />
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-1 [&_p]:font-medium [&_span]:text-sm">
                    <p>{t('settings:personal_information:email_address')}</p>
                    <span>{user.email}</span>
                </div>

                <div className="flex flex-col gap-1">
                    <div className="flex items-center">
                        {isCompleted && (
                            <Switch
                                id="notifications"
                                checked={user.sendNotificationsToPhone}
                                onChange={
                                    changeOptionSmsMutation.isPending
                                        ? undefined
                                        : value => changeOptionSmsMutation.mutate({send_notifications_to_phone: value})
                                }
                            />
                        )}
                        <span className="font-medium">{t('settings:sms')}</span>
                    </div>

                    {userMeQuery.isPending ? (
                        <Spinner size={16} />
                    ) : (
                        <SettingsCard
                            isCompleted={isCompleted}
                            className={cn('[&_span]:text-sm [&_h3]:text-sm', isCompleted && 'flex-row')}
                        >
                            <h3>
                                {isCompleted
                                    ? // replace + to avoid ++ when user already has + in the phone number
                                      `+${user.phone?.replace(/\+/g, '')}`
                                    : t('settings:personal_information:notification_description')}
                            </h3>

                            <Button variant="tertiary" shape="text" onClick={() => setIsChangePhoneModalOpen(true)}>
                                {t(isCompleted ? 'commons:change' : 'settings:personal_information:add_number')}
                            </Button>
                        </SettingsCard>
                    )}
                </div>
            </div>

            {isChangePhoneModalOpen && (
                <ChangePhoneModal onClose={() => setIsChangePhoneModalOpen(false)} phoneNumber={user.phone} />
            )}
        </div>
    )
}
